export const DEFAULT_COLOR = '#296AE1';
export const DEFAULT_EMOJI = '🌼';
export const DEFAULT_CURRENCY = 'eur';

export const TERMS_OF_SERVICE = '/files/terms.pdf';
export const PRIVACY_POLICY = '/files/privacy.pdf';
export const GDPR_POLICY = '/files/gdpr.pdf';

export const SUPPORT_EMAIL = 'support@fixtender.com';
